import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import { PagingArgument } from 'src/lib/utilities/api/patterns/pagination/paging.argument';
import {
	PaperworkApprovalArgument,
	PaperworkApprovalModel,
	PaperworkApprovalTrackerArgument,
	PaperworkApprovalTrackerModel,
	PaperworkApproveRejectArgument,
} from './paperwork-approval.model';

@Injectable({
	providedIn: 'root',
})
export class PaperworkApprovalService {
	constructor(private httpClient: HttpClient) {}

	// Unapproved Paperwork OLD CALL not being used currently
	public getPaperworkApprovalList = (): Observable<
		PaperworkApprovalModel[]
	> => {
		return this.httpClient
			.get<{
				paperwork_requests: unknown[];
			}>(`/api/v1/paperwork/unapproved`)
			.pipe(
				mapResponse(
					(r) => plainToInstance(PaperworkApprovalModel, r.paperwork_requests),
					{
						errorCode: 'B4A8D029',
					},
				),
			);
	};

	public getStudentPendingPaperwork = (
		uid: number,
	): Observable<PaperworkApprovalTrackerModel> => {
		return this.httpClient
			.get<unknown>(`/api/v1/students/${uid}/enrollment/form/paperwork/pending`)
			.pipe(
				mapResponse((r) => plainToInstance(PaperworkApprovalTrackerModel, r), {
					errorCode: '912F95FD',
				}),
			);
	};

	public getPendingPaperworkApprovals = (
		args: PagingArgument<PaperworkApprovalTrackerArgument>,
	): Observable<PaperworkApprovalTrackerModel> => {
		return this.httpClient
			.post<unknown>(`/api/v1/paperwork/pending`, args)
			.pipe(
				mapResponse((r) => plainToInstance(PaperworkApprovalTrackerModel, r), {
					errorCode: 'F03760FA',
				}),
			);
	};

	public editPendingPaperwork = (
		studentId: number,
		paperworkId: number,
		internal_comment: string, // only internal comment can be edited
	): Observable<unknown> => {
		return this.httpClient
			.post<unknown>(
				`/api/v1/students/${studentId}/paperwork/pending/${paperworkId}`,
				{
					internal_comment,
				},
			)
			.pipe(
				mapResponse((r) => r, {
					errorCode: 'A572B00F',
				}),
			);
	};

	public approvePendingPaperwork = (
		studentId: number,
		args: PaperworkApprovalArgument,
	): Observable<unknown> => {
		return this.httpClient
			.post<unknown>(`/api/v1/students/${studentId}/paperwork/approve`, args)
			.pipe(
				mapResponse((r) => r, {
					errorCode: '6EF4BD9E',
				}),
			);
	};

	//Approve and Reject Paperwork OLD CALL not being used currently
	public approvePaperwork = (
		studentId: number,
		args: PaperworkApproveRejectArgument,
	): Observable<unknown> => {
		return this.httpClient
			.post<unknown>(`/api/v1/students/${studentId}/paperwork/approve`, args)
			.pipe(
				mapResponse((r) => r, {
					errorCode: 'FLAF1622',
				}),
			);
	};

	public refreshPaperwork = () => {
		return this.httpClient.post<unknown>(`/api/v1/paperwork/refresh`, {}).pipe(
			mapResponse((r) => r, {
				errorCode: '0AD73E2A',
			}),
		);
	};
}
